var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('div',{staticClass:"table-data-header"},[_vm._v(_vm._s(_vm.dataHeader))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.data)}}),_vm._v(" "),(_vm.showTooltip)?_c('tooltip',{attrs:{"tooltip-text":_vm.tooltipText}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }